<div class="container" *ngIf="isPerformanceData && !isUnderDateThreshold">
  <app-area-chart
    *ngIf="isShareOfVoice"
    [data]="data!"
    [brandColors]="brandColors"
    [brandLineColorsMap]="brandLineColorsMap"
    [format]="format">
  </app-area-chart>

  <app-spline-chart
    *ngIf="!isShareOfVoice"
    [data]="data!"
    [brandColors]="brandColors"
    [format]="format">
  </app-spline-chart>
</div>

<app-loader *ngIf="loading"></app-loader>
<app-no-widget-data *ngIf="!loading && (!isPerformanceData || isUnderDateThreshold)"
  [svgSrc]="isUnderDateThreshold ? ('svg/no-widget-data-performance-date-threshold.svg' | assetVersion) : undefined">
</app-no-widget-data>
